export interface FailureResponse {
    message: string
}
export class GeneralException {
    code: number;
    response: FailureResponse;
    
    constructor(code: number, response: FailureResponse) {
        this.code = code;
        this.response = response;
    }
}